import { supabase } from '../supabaseClient';

/* Accès aux données « jira_authors ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function updateJiraAuthor(accountId, included) {
  return supabase
    .from('jira_authors')
    .update({ included, updated_at: new Date().toISOString() })
    .eq('account_id', accountId);
}
